import { Resource as i } from "@coveo/platform-client";
const s = class s extends i {
  /**
   * Send a notification event to an organization
   * @param organizationId The organization ID to send to.
   * @param requestModel The request model.
   * @returns void
   */
  send(t, e) {
    return this.api.post(
      this.buildPath(`${s.baseUrl}/${t}`, {}),
      e
    );
  }
  /**
   * Send a notification event to multiple organizations
   * @param requestModel The request model.
   * @param params The options.
   * @returns void
   */
  sendMultiple(t, e) {
    return this.api.post(this.buildPath(s.baseUrl, e), t);
  }
};
s.baseUrl = "/rest/notifications/events/send";
let r = s;
export {
  r as NotificationEventResource
};
//# sourceMappingURL=NotificationEventResource.js.map
